<script setup lang="ts">

</script>

<template>
  <div class="car-invoice-v2__header">
    <div class="car-invoice-v2__header-left">
      <span class="text">Auto Export from U.S.A.</span>
      <img
        src="assets/img/pdf/logo/loan.png"
        alt="Indigo Loan"
        class="logo"
      >
    </div>
    <div class="car-invoice-v2__header-right">
      <div class="list">
        <span class="car-list-item bold">Shipping</span>
        <span class="car-list-item">Tbilisi</span>
        <span class="car-list-item">17 N. Irbakhi St / 21 A. Tsurtsumia St</span>
        <span class="car-list-item">Tel:+032 2 502002</span>
        <a
          href="mailto:info@carsindigo.com"
          class="car-list-item link"
        >info@carsindigo.com</a>
        <a
          href="https://www.carsindigo.com/"
          class="car-list-item link"
        >www.carsindigo.com</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.car-invoice-v2__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #000;

  &-left {
    display: flex;
    flex-direction: column;

    .text {
      display: block;
      font-size: 8px;
      margin-bottom: 5px;
    }

    .logo {
      width: 165px;
      height: 40px;
    }
  }

  &-right {
    .list {
      display: flex;
      flex-direction: column;

      &-item {
        font-size: 8px;
        text-align: right;
        margin-bottom: 3px;

        &.bold {
          font-weight: 700;
        }

        &.link {
          text-decoration: underline;
          color: #000;
        }
      }
    }
  }
}
</style>
